module.exports = __webpack_public_path__ + "assets/img/DS-study (2).22318932.jpg";